/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 */
/**
 * localStorage scope GD
 */
var User = /** @class */ (function () {
    function User() {
        var user = JSON.parse(localStorage.getItem('user') || '{}');
        this.id = user.id;
        this.currency = user.currency;
        this.name = user.name;
        this.actorType = user.actorType;
        this.locale = user.locale;
        this.loyalty = user.loyalty;
        this.bonusVisualization = user.bonusVisualization;
        this.payout = user.payout;
        this.forcePayout = user.forcePayout || false;
        this.boku = user.boku;
        this.avatarUrl = user.avatarUrl;
    }
    return User;
}());
export { User };
//# sourceMappingURL=User.js.map